import { Injectable } from '@angular/core';
import { SharedService } from '../services/shared.service';

@Injectable()
export class SectorHelper {

  constructor(private sharedService: SharedService) {}

  get sectors(): any {
    return this.sharedService.getSectorList();
  }

  getSectorColor(sector: string): string {
    let bg: string;
    switch (sector) {
      case 'Štampa':
        bg = 'blue';
        break;
      case 'Plastika':
        bg = 'green';
        break;
      case 'Dorada':
        bg = 'yellow';
        break;
      case 'Metal':
        bg = 'red';
        break;
      case 'Kartonaža':
        bg = 'orange';
        break;
      case 'Montaža':
        bg = 'violet';
        break;
    }

    return bg;
  }

   getSectorColorGraph(sector: string): string {
    let bg: string;
    switch (sector) {
      case 'Štampa':
        bg = '#4A90E2';
        break;
      case 'Plastika':
        bg = '#008A6B';
        break;
      case 'Dorada':
        bg = '#DCB000';
        break;
      case 'Metal':
        bg = '#EF4136';
        break;
      case 'Kartonaža':
        bg = '#FE6431';
        break;
      case 'Montaža':
        bg = '#9013FE';
        break;
    }

    return bg;
  }
}
